import { render, staticRenderFns } from "./NotificationsBar.vue?vue&type=template&id=4c2c3999&"
import script from "./NotificationsBar.vue?vue&type=script&lang=js&"
export * from "./NotificationsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports